<template>
  <div class="device025_dimming_wraper device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name z_ellipsis1">{{objData.remark}}</div>

    <div class="content025_wraper content027_wraper">
      <div class="data025_show data_027show">
        <!-- <span>0%</span> -->
        <progress-bar
          class="device025_baiguang_progress"
          v-on:valueChange="baiValueChange"
          :width="200"
          :maxValue="100"
          :setValue="userControlData.openState"
        >
          <span slot="sliderTitle">白光:</span>
          <span slot="sliderLeftTips">0%</span>
          <span slot="sliderRightTips">100%</span>
        </progress-bar>

        <progress-bar
          class="device025_nuanguang_progress"
          v-on:valueChange="nuanValueChange"
          :width="200"
          :maxValue="100"
          :setValue="userControlData.openStateValue"
        >
          <span slot="sliderTitle">暖光:</span>
          <span slot="sliderLeftTips">0%</span>
          <span slot="sliderRightTips">100%</span>
        </progress-bar>
        <!-- <span>100%</span> -->
      </div>
    </div>
    <div
      class="device_025_btn device_control_btn public_control_btn"
      :class="dimming2BtnFlang? 'public_control_btn_on':''"
      @click="device025BtnClickHandle"
    >{{deviceStateComputed}}</div>
    <!-- <BUtton @click="btnhandle">按钮</BUtton> -->
  </div>
</template>

<script>
///需要注意的是  调光进度条和 按钮之间的翻转逻辑 两个进度条有一个大于0 按钮显示已打开 两个进度条均小于等于0显示 已关闭 。
//操作按钮打开 两个进度条100 关闭 两个进度条0
///需要注意的是按钮的状态是虚拟的，但是要根据实际的进度条状态进行实时状态的更新。
import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
import ProgressBar from "components/common/progressbar/progress-bar";
export default {
  data() {
    return {
      userControlData: {
        ///用户设置的缓冲数据
        openState: this.objData.openState, ///白光 0-100
        openStateValue: this.objData.openStateValue, //暖光 0-100
        openStateValue1: this.objData.openStateValue1, ///无用
        openStateValue2: this.objData.openStateValue2 ///无用
      },
      dimming2BtnFlang: 0 ///按钮的虚拟状态
    };
  },
  props: {
    objData: Object ///要控制设备的数据
  },
  components: {
    ProgressBar
  },
  methods: {
    device025BtnClickHandle() {
      ///按钮按下
      // deviceStateFlip(this.userControlData); ///对设备的状态0和1进行翻转
      if (this.dimming2BtnFlang === 0) {
        // this.dimming2BtnFlang =1 ;
        this.userControlData.openState = 100;
        this.userControlData.openStateValue = 100;
      } else {
        this.userControlData.openState = 0;
        this.userControlData.openStateValue = 0;
      }

      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    baiValueChange(data) {
      ///白光进度条值改变
      console.log("子组件传回的值" + data);
      if (this.userControlData.openState === data) return;
      this.userControlData.openState = data;
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    nuanValueChange(data) {
      ///暖光进度条值改变
      console.log("子组件传回的值" + data);
      if (this.userControlData.openStateValue === data) return;
      this.userControlData.openStateValue = data;

      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
    // btnhandle() {
    //   this.userControlData.openStateValue++;
    // }
  },
  computed: {
    deviceStateComputed() {
      if (
        this.userControlData.openState <= 0 &&
        this.userControlData.openStateValue <= 0
      ) {
        this.dimming2BtnFlang = 0;
        console.log("打开关闭属性已计算 0");
        return "已关闭";
      } else {
        this.dimming2BtnFlang = 1;
        console.log("打开关闭属性已计算 1");
        return "已打开";
      }
    }
  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    },
    "objData.openStateValue": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue = val;
      }
    }
  }
};
</script>

<style>
.device025_dimming_wraper {
  height: 450px;
}
.data025_show {
  margin-top: 20px;
  margin-bottom: 60px;
  position: relative;
}
.device025_baiguang_progress {
  position: absolute;
  left: 50px;
  top: 0px;
}
.device025_nuanguang_progress {
  position: absolute;
  left: 50px;
  top: 100px;
}
.device_025_btn {
  width: 90%;
}
</style>
